var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 5.25H3.5C3.09 5.25 2.75 4.91 2.75 4.5C2.75 4.09 3.09 3.75 3.5 3.75H21.5C21.91 3.75 22.25 4.09 22.25 4.5C22.25 4.91 21.91 5.25 21.5 5.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.97 10.25H3.5C3.09 10.25 2.75 9.91 2.75 9.5C2.75 9.09 3.09 8.75 3.5 8.75H12.97C13.38 8.75 13.72 9.09 13.72 9.5C13.72 9.91 13.39 10.25 12.97 10.25Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 15.25H3.5C3.09 15.25 2.75 14.91 2.75 14.5C2.75 14.09 3.09 13.75 3.5 13.75H21.5C21.91 13.75 22.25 14.09 22.25 14.5C22.25 14.91 21.91 15.25 21.5 15.25Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.97 20.25H3.5C3.09 20.25 2.75 19.91 2.75 19.5C2.75 19.09 3.09 18.75 3.5 18.75H12.97C13.38 18.75 13.72 19.09 13.72 19.5C13.72 19.91 13.39 20.25 12.97 20.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.3ce3f678b00f371c6ef1950417d943f0.svg";
export { ForwardRef as ReactComponent };